export class StorageKeys {
    public static AUTH_TOKEN = "auth_token";
    public static ACTIVE_LANGUAGE = "activeLanguage";
}
